import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import { useNavigate } from 'react-router-dom';

export default function LoginRequiredModal({ isOpen, onClose, message }) {
  const navigate = useNavigate();

  return (
    <Modal isOpen={isOpen} onClose={onClose} backdrop="blur" 
      classNames={{
        wrapper: 'z-[1200]',
        base: 'bg-gray-800 z-[1200]'
      }}>
      <ModalContent className='z-[1200]'>
        <ModalHeader className="text-lg font-bold text-white">Login Required</ModalHeader>
        <ModalBody>
          <p className="text-white">{message}</p>
        </ModalBody>
        <ModalFooter className="flex justify-end space-x-3">
          <Button onPress={onClose} variant="light" className="text-white border border-gray-500">
            Cancel
          </Button>
          <Button
            className="bg-indigo-600 hover:bg-indigo-700 text-white"
            onPress={() => {
              onClose(); // optional: close modal before navigation
              navigate('/Auth');
            }}
          >
            Log In
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
